import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка зарплат
    async getSalaries(data) {
      let params = this.makeSearchParams(data);

      if (data.period) {
        params.set("period", data.period);
      }

      if (data.org_id > 0) {
        params.set("org_id", data.org_id);
      }

      return await this.get(`salaries?${params.toString()}`);
    },
    // Получение зарплаты по id
    async getSalaryById(id) {
      return await this.get(`salaries/id/${id}`);
    },
    // Создание зарплаты
    async postSalary(data) {
      return await this.post('salaries', data);
    },
    // Изменение зарплаты
    async putSalary(data) {
      return await this.put(`salaries/${data.id}`, data);
    },

    // Получение новой выплаты по сотруднику за период
    async getNewSalaryStaff(data) {
      let params = this.makeSearchParams(data);

      if (data.period) {
        params.set("period", data.period);
      }
      if (data.staff_id) {
        params.set("staff_id", data.staff_id);
      }

      if (data.salary_type_id) {
        params.set("salary_type_id", data.salary_type_id);
      }

      return await this.get(`salary_staff/salary?${params.toString()}`);
    },
    // Получение сводной таблицы по зарплатам
    async getAccrualSalarySummary(data) {
      let params = this.makeSearchParams(data);

      if (data.period) {
        params.set("period", data.period);
      }

      if (data.org_id) {
        params.set("org_id", data.org_id);
      }

      if (data.department_id) {
        params.set("department_id", data.department_id);
      }

      return await this.get(`accrual_salary?${params.toString()}`);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/salaries.js